import React from 'react';

import styled from 'styled-components';

import { Modal, ModalContentText } from 'src/app/components/lib/modal';

type LocationSuspendedModalProps = {
  onClose: () => void;
  open: boolean;
};

function LocationSuspendedModal({ open, onClose }: LocationSuspendedModalProps) {
  return (
    <Modal
      Content={
        <ModalContentText>
          Your Dutchie Account has been suspended to reactivate, email{' '}
          <Link href='mailto:suspensionreview@dutchie.com'>suspensionreview@dutchie.com</Link>
        </ModalContentText>
      }
      open={open}
      title='Location suspended'
      onClose={onClose}
    />
  );
}

export default LocationSuspendedModal;

const Link = styled.a`
  text-decoration: underline;
  font-weight: bold;
`;
